export const UeCountries = [
  'Austria',
  'Belgio',
  'Bulgaria',
  'Cipro',
  'Croatia',
  'Danimarca',
  'Estonia',
  'Finlandia',
  'Francia',
  'Germania',
  'Grecia',
  'Irlanda',
  'Italia',
  'Lettonia',
  'Lituania',
  'Lussemburgo',
  'Malta',
  'Paesi Bassi',
  'Polonia',
  'Portogallo',
  'Rep. ceca',
  'Romania',
  'Slovacchia',
  'Slovenia',
  'Spagna',
  'Svezia',
  'Ungheria',
]